import { addHours, subMinutes } from 'date-fns';
import { DEFAULT_SCHEDULE_OFFSET_HOURS } from './buildQuickTimes';

interface GetInitialScheduleDateArgs {
  time: Date | null;
  minDate?: Date | null;
  maxDate?: Date | null;
}

export const getInitialScheduleDate = ({ time, minDate, maxDate }: GetInitialScheduleDateArgs) => {
  if (time) {
    return time;
  }

  const suggested = addHours(new Date(), DEFAULT_SCHEDULE_OFFSET_HOURS);

  if (minDate && suggested.getTime() <= minDate.getTime()) {
    return addHours(minDate, DEFAULT_SCHEDULE_OFFSET_HOURS);
  }

  if (maxDate && suggested.getTime() >= maxDate.getTime()) {
    return subMinutes(maxDate, 1);
  }

  return suggested;
};
